<template>
  <div class="container-fluid villa-main">
    <header>
      <h1>
        VILLA
        <span class="slim-text">VERANZA</span>
      </h1>
    </header>
    <div class="villa-main__caption col-xl-12">
      <ul>
        <li>
          <font-awesome-icon :icon="['fas', 'map']" />&nbsp;&nbsp; CABO SAN
          LUCAS, MEXICO
        </li>
        <li>
          <font-awesome-icon :icon="['fas', 'bed']" />&nbsp;&nbsp; SLEEPS 16
        </li>
        <li class="booking-scroll-link">
          <a href="#booking">RESERVE NOW</a>
          <font-awesome-icon :icon="['fas', 'chevron-right']" />
        </li>
      </ul>
    </div>
    <div class="image-with-text">
      <div class="image-with-text__text">
        <h3>CABO SAN LUCAS, MEXICO</h3>
        <p>
          VJust a 5-minute walk to the Pedregal private beach, our 6-star
          platinum Villa Veranza welcomes you for total relaxation, luxurious
          amenities, magnificent views of the bluest skies and the colors of the
          Pacific ocean, as well as easy access to the warm sands of
          sun-drenched beaches.
        </p>
      </div>
    </div>
    <div class="villa-main__showcase-cards row">
      <b-card
        :img-src="
          require('../assets/gallery/villas/villa_veranza/web/Veranza-1-min.jpg')
        "
        img-top
        class="col-xl-4"
      >
        <b-card-text>
          One of our unique features as a luxury vacation rental is that our
          in-house professional chef, concierge, and daily housekeeping are
          included in the nightly rate! We are very pleased to be one of the
          only villas providing chef services and at a great value for Cabo San
          Lucas villas. Nestled into a hillside, Villa Veranza’s 5-level, 7,400
          square foot property is located in the upscale community of Pedregal
          and ocean views are abundant from almost anywhere you are in the
          villa. There are eight uniquely decorated bedroom suites, all with
          private baths, indoor/outdoor showers, custom marble sinks,
          extraordinary finishes, California king beds, and satellite TV (DVR
          and sound systems).
        </b-card-text>
      </b-card>
      <b-card
        :img-src="
          require('../assets/gallery/villas/villa_veranza/web/Veranza-44-min.jpg')
        "
        img-top
        class="col-xl-4"
      >
        <b-card-text>
          Our villa boasts an abundance of Cabo luxury with 15′ ceilings and
          plenty of open entertaining space in the living room and gourmet
          kitchen located on the main level. There’s a 70′ high definition TV,
          stereo sound system, Wi-Fi, pool table and generous seating
          throughout. The kitchen features top of the line appliances, a wine
          refrigerator, seating for 14, and plenty of other amenities. Relax and
          enjoy your stay with the exquisite culinary arts of our in-house
          professional chef. We have a spa room set up for in-house masseuse
          services allowing your group to enjoy a massage at a fraction of the
          rate of an outside spa. Please note, the masseuse services are
          available upon request. From the massage table, take just a few steps
          to the relaxing jacuzzi on a private deck overlooking the white water
          beach. There’s also free gym access to The Spa at Pedregal included in
          your vacation rental.
        </b-card-text>
      </b-card>
      <b-card
        :img-src="
          require('../assets/gallery/villas/villa_veranza/web/Veranza-32-min.jpg')
        "
        img-top
        class="col-xl-4"
      >
        <b-card-text>
          Enjoy panoramic views of the Pacific ocean from the best choice in
          Cabo San Lucas villas while entertaining outdoors on over 3,000 square
          feet of decks and terraces. Your group will relish the spacious
          infinity pool, hot tub, outdoor kitchen with BBQ, covered dining area,
          46′ outdoor television, and impressive built-in sofas and lounge
          chairs. There are plenty of Cabo San Lucas excursions to consider and
          so much to do during your vacation! Walk to the beach, or take a
          10-minute drive to downtown beaches. Enjoy amazing food, drinks, and
          dancing. Go whale watching, take a walking tour, or stay back and soak
          up Cabo luxury around the villa. Try sailing and kayaking or rent a
          stand-up paddleboard.
        </b-card-text>
      </b-card>
    </div>
    <b-carousel
      id="carousel-1"
      v-model="slide"
      controls
      indicators
      background="#ababab"
      img-width="1024"
      img-height="280"
      style="text-shadow: 1px 1px 2px #333;"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
      class="main-carousel"
    >
      <!-- Text slides with image -->
      <b-carousel-slide
        :img-src="
          require('../assets/gallery/villas/villa_veranza/web/Veranza-1-min.jpg')
        "
      ></b-carousel-slide>

      <!-- Slides with custom text -->
      <b-carousel-slide
        :img-src="
          require('../assets/gallery/villas/villa_veranza/web/Veranza-9-min.jpg')
        "
      ></b-carousel-slide>

      <!-- Slides with image only -->
      <b-carousel-slide
        :img-src="
          require('../assets/gallery/villas/villa_veranza/web/Veranza-45-min.jpg')
        "
      ></b-carousel-slide>
    </b-carousel>
    <router-link to="/gallery">
      <b-button
        style="margin:auto;margin-top: 40px;margin-bottom: 40px;"
        class="submit"
        variant="primary"
        >Show more images</b-button
      >
    </router-link>
    <div class="image-with-text">
      <div class="image-with-text__text">
        <p>
          With a great value on all this Cabo luxury, professional staff, superb
          ambiance, and plenty of things to do in and outside of the villa and
          surrounding areas, your Cabo San Lucas vacation will be a very special
          and memorable one!
        </p>
      </div>
    </div>
    <AmenetiesVeranza />
    <h3 style="margin-top: 40px;" id="booking">CONTACT</h3>
    <p>
      The datepicker below shows availabilty directly from VRBO. This form does
      not officially reserve the location.
    </p>
    <DatePicker
      url="https://api.sitebot.com/api/vrbo/hotel-datepicker.json?id=579780"
    />

    <SubContact />
    <Testimonials
      url="https://api.sitebot.com/api/vrbo/reviews.json?id=579780"
    />
  </div>
</template>

<script>
import Testimonials from "../components/Testimonials";
import SubContact from "../components/SubContact";
import DatePicker from "../components/DatePicker";
import AmenetiesVeranza from "../components/AmenetiesVeranza";

export default {
  data() {
    return {
      slide: 0,
      sliding: null,
    };
  },
  components: {
    Testimonials,
    SubContact,
    DatePicker,
    AmenetiesVeranza,
  },
  methods: {
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/main";

.villa-main {
  font-family: "Raleway", sans-serif;
  &__showcase-cards {
    margin-top: 40px;
    margin-right: 0px;
    margin-left: 0px;
    margin-bottom: 40px;
    .card-text {
      font-family: "Raleway", sans-serif;
      line-height: 2rem;
    }
    .card {
      border: none;
    }
  }
  &__caption {
    padding-left: 0px !important;
    padding-right: 0px !important;
    ul {
      display: flex;
      list-style: none;
      justify-content: space-around;
      margin: auto;
      color: white;
      font-weight: 700;
      background-color: rgba(0, 0, 0, 0.8);
      width: 100%;
      margin-top: 20px;
      padding-left: 18%;
      padding-right: 20%;
      padding-top: 20px;
      padding-bottom: 20px;
      li:nth-child(3) {
        color: $text--blue--dark;
      }
      li {
        svg {
          color: $text--blue--dark;
        }
      }
      @media only screen and (max-width: 800px) {
        padding-left: 1%;
        padding-right: 3%;
      }
    }
    .booking-scroll-link {
      position: relative;
      a {
        color: $text--blue--dark;
        &:hover {
          color: $text--blue--dark;
          text-decoration: none;
        }
      }
      .fa-chevron-right {
        position: absolute;
        top: 12%;
        left: 100%;
        margin-left: 5px;
        transition: all 0.3s ease-in-out;
      }
      &:hover {
        .fa-chevron-right {
          left: 105%;
        }
      }
    }
  }
  .main-carousel {
    width: 60vw;
    margin: auto;
    @media only screen and (max-width: 1200px) {
      width: 100%;
    }
  }
  .image-with-text {
    background-image: url("../assets/gallery/villas/villa_andaluza/web/Andaluza-41-min.jpg");
    background-size: cover;
    background-repeat: none;
    background-position-y: center;
    line-height: 2rem;
    color: white;
    padding: 80px 0px 80px 0px;
    height: auto;

    &__text {
      background-color: rgba(0, 0, 0, 0.4);
      padding-top: 20px;
      padding-bottom: 20px;
    }

    h3 {
      font-weight: 800;
    }
    p {
      width: 70%;
      margin: auto;
      font-weight: 700;
      font-size: 20px;
      margin-top: 20px;
    }
  }
}
header {
  margin-top: 16px;
  display: flex;
  justify-content: center;
  h1 {
    font-size: 5rem;
    font-weight: 700;
    .slim-text {
      font-weight: 200;
    }
  }
  @media only screen and (max-width: 1000px) {
    h1 {
      font-size: 2rem;
    }
  }
}
h3 {
  font-size: 3rem;
}
</style>
